import React from "react";
import { Box, Heading, Text, Image, Anchor } from "../../components/elements";
import { IMAGE_404 } from "../../utils/image.constants";
import { DASHBOARD_ROUTES } from "../dashboard/constants";

export function Error() {
  return (
    <Box className="mc-error">
      <Image src={IMAGE_404} alt="404" />
      <Heading>ooops! this page can't be found.</Heading>
      <Text>It's looks like nothing was found at this location.</Text>
      <Anchor href={DASHBOARD_ROUTES.root} className="mc-btn primary" icon="home" text="back to home" />
    </Box>
  );
}
